import { object, string, number } from 'yup'
import { DataGridSettings } from '../../interfaces/DataGrid/DataGridSettings'

export const suppOriginValidationSchema = object({
  supplierId: number()
    .required('El campo Proveedor es requerido')
    .min(1, 'Debe seleccionar un proveedor'),
  supplierOriginName: string()
    .required('Nombre Origen es un campo requerido')
    .max(50, 'Máximo 50 caracteres.'),
  productControlPercentage: number()
    .min(0, 'Minimo 0%')
    .max(100, 'Máximo 100%'),
  comments: string().max(200, 'Máximo 200 caracteres.')
})

export const dataGridSettings: DataGridSettings = {
  spacing: 2,
  sortingMode: 'single',
  columns: [
    {
      title: 'Razón Social Proveedor',
      dataField: 'id',
      xs: 12,
      sm: 6,
      lg: 3,
      allowSorting: false
    },
    {
      title: 'Nombre Origen',
      dataField: 'supplierOriginName',
      xs: 12,
      sm: 6,
      lg: 3,
      allowSorting: false,
      sortOrder: 'DESC'
    },
    {
      title: 'Mercadería a Revisar',
      dataField: 'productControlPercentage',
      xs: 12,
      sm: 6,
      lg: 2,
      allowSorting: false
    },
    {
      title: 'Draft',
      dataField: 'draft',
      xs: 12,
      sm: 6,
      lg: 1,
      allowSorting: false
    },
    {
      title: '',
      dataField: 'column-buttons',
      xs: 12,
      sm: 6,
      lg: 3,
      allowSorting: false
    }
  ]
}
